module.exports = __webpack_public_path__ + "img/angststoerungen_1920.a18b9960.png";